<template>
    <div>
        <a href="#" @click="showModal()" class="caption caption-margins round-medium card" :id="menu">
            <div class="mobile-display" :style="loadMobileBg">
                <img v-bind:src="'images/mpower-new/explore_the_world/iPad/'+bannerBadge" class="banner-badge" :style="badgeSlide">
                <div class="caption-bottom">
                    <div class="caption-padding left-text">
                        <div class="slide_position">
                            <p class="city">{{title}}</p>
                            <!-- <p class="country">{{ title1 }}</p> -->
                        </div>
                        <p class="under-heading color-white bottom-2 qualifying-period">{{ description2 }}  <span v-if="modal=='thailand-modal'" v-html="description3"></span> </p>
                    </div>
                </div>
            </div>
            <div class="ipad-display" :style="loadTabletBg">
                <img v-bind:src="'images/mpower-new/explore_the_world/iPad/'+bannerBadge" class="banner-badge" :style="badgeSlide">
            
                <div class="caption-bottom">
                    <div class="caption-padding left-text">
                        <div class="slide_position">
                            <p class="city">{{title}}</p>
                            <!-- <p class="country">{{ title1 }}</p> -->
                        </div>
                        <p class="under-heading color-white bottom-2 qualifying-period">{{ description2 }}  <span v-if="modal=='thailand-modal'" v-html="description3"></span> </p>
                    </div>
                </div>
            </div>
        </a>
        <ExploreBannerContent
            :modal="loadModal"
            :title="loadTitle"
            :title1="loadTitle1"
            :positionSlide2="loadPositionSlide2"
            :image="loadImage"
            :color="loadColor"
            :description1="loadDescription1"
            :description2="loadDescription2"
            :description3="loadDescription3"
            :link="loadLink"

            :y1y2agentspvi="loadY1y2agentspvi"
            :agentspvi="loadAgentspvi"
            :leaderpspvi="loadLeaderpspvi"
            :directunitpvi="loadDirectunitpvi"
            :grouppvi="loadGrouppvi"

            :badge="loadBadge"
            :video="loadVideo"
        />
       
    </div>
</template>
<script>
import ExploreBannerContent from '../components/ExploreBannerContent.vue'

export default {
  name: 'ExploreBanner',
  props: {
    modal: String,
    icon: String,
    title: String,
    title1: String,
    description1: String,
    description2: String,
    description3: String,
    image: String,
    positionSlide2: String,
    link: String,
    menu: String,

    y1y2agentspvi: String,
    agentspvi: String,
    leaderpspvi: String,
    directunitpvi: String,
    grouppvi: String,

    badge: String,
    bannerBadge: String,
    video: String
  },
  computed: {
    loadModal(){
        return this.modal
    },
    loadIcon(){
        return this.icon
    },
    loadTitle(){
        return this.title
    },
    loadTitle1(){
        return this.title1
    },
    loadDescription1(){
        return this.description1
    },
    loadDescription2(){
        return this.description2
    },
    loadDescription3(){
        return this.description3
    },
    loadColor(){
        return this.color
    },
    loadVideo(){
        return this.video
    },
    loadImage(){
        return this.image
    },
    loadPositionSlide2(){
        return this.positionSlide2
    },
    loadLink(){
        return this.link
    },
    loadMenu(){
        return this.menu
    },


    loadY1y2agentspvi(){
        return this.y1y2agentspvi
    },
    loadAgentspvi(){
        return this.agentspvi
    },
    loadLeaderpspvi(){
        return this.leaderpspvi
    },
    loadDirectunitpvi(){
        return this.directunitpvi
    },
    loadGrouppvi(){
        return this.grouppvi
    },

    loadBadge(){
        return this.badge
    },
    loadBannerBadge(){
        return this.bannerBadge
    },
    loadMobileBg(){
        return {
            'backgroundImage':'url(\'images/mpower-new/explore_the_world/' + this.image + '\')',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'height': '191px'
        };
    },

    loadTabletBg(){
        return {
            'backgroundImage':'url(\'images/mpower-new/explore_the_world/iPad/' + this.image + '\')',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'height': '191px'
        };
    },
    positionSlide(){
        // if(this.modal==='croatia-modal'){
            return {left: this.positionSlide2, top:'0%'};
        // }
        // else{
        //     return {left: this.positionSlide2};
        // }
    },

    badgeSlide(){
        // if(this.modal==='croatia-modal'){
            return { bottom:'0%', left:'0%'};
        // }
        // else{
        //     return {left: this.positionSlide2};
        // }
    }
    },
    components:{
        ExploreBannerContent
    },
   
    methods: {
      showModal() {
        document.querySelector(".header-s").style.display = "none";
        document.querySelector(".header").style.zIndex = "1";
        this.$modal.show(this.modal)
      },
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        //this.$refs['my-modal'].toggle('#toggle-btn')
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* .background-ovr {
        background-size: auto !important;
    } */
.city{
    font-family: "BillionDreams_PERSONAL";
    font-size: 58px !important;
    color: #ffffff;
    margin-bottom: 5px !important;
    line-height: 58px;
}

.country{
    font-family: "MyriadPro-Regular";
    font-size: 17px !important;
    color: #ffffff;
    letter-spacing: 3px;
    text-transform: uppercase;
}

.qualifying-period{
  
  font-size: 11px !important;
  /* margin-top: 2px; */
  padding-left: 3px;;
  /* margin-bottom: 10px; */
  line-height: 18px;
}
.bg-gradient{
    opacity: 0.8;
    background: none;
}
/* .card{
    text-align: left;
    height: 300px;
    width: 100%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
} */
.caption-top{
    left: 7px;
    top: 40px;
}
.caption-bottom p{
    padding-left: 3px;
    margin-bottom: 0;
    font-size: 9px;
}
.caption-bottom h1{
    font-size: 50px;
}
.caption-padding{
    padding:15px 20px 10px;
    background-image: linear-gradient(#00000000, #1f1f1f);
}
h5{
    font-size: 13.3px;
}
.card .slide_position{
    position: relative;
}
.card img.slide{
    height: 50px;
    width: 60px;
    position: absolute;
    top: 10px;
    /* left: 130px; */
}

.card img.banner-badge{
    height: 181px;
    width: auto;
    position: absolute;
    /* top: 10px; */
    /* left: 130px; */
}
.caption-margins{
    margin: 0px 15px 20px 15px!important;
}
.h1-font{
    font-size: 35px !important;
}

@media (max-width: 720px) {
    .city{
        font-size: 48px !important;
        line-height: 30px;
        margin-bottom: 3px !important;
        line-height: 48px !important;
    }
}

@media (max-width: 424px) {
    .city{
        font-size: 34px !important;
        line-height: 34px !important;
    }

    .caption-image {
        height: 250px;
    }
}
/* .caption-image{
    min-height: 300px;
} */
</style>
